import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button
} from "reactstrap"
import classnames from 'classnames'
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import moment from "moment"

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import KomptLengkap from './tabs/KomptLengkap';
import Kompt from './tabs/Kompt';
import MatrixKinerja from './tabs/MatrixKinerja';
import SaranPengembangan from './tabs/SaranPengembangan';
import KesesuaianPenempatan from './tabs/KesesuaianPenempatan';
import './custom.css';

class IndexView extends Component {
    
    detailBloc = new DetailBloc()
    
    constructor(props) {
        super(props)
        this.state = {
            detail:{},
            acData : null,
            acDetail : [{}],
            levelComps: [
                {
                    name: "",
                    level : 1
                },
            ],
            activeTab: '1',
        }
    }
    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }
    loadAcData = async () => {
        const query = {
            uuid: this.props.uuid
        }
        // console.log(query)
        await this.detailBloc.fetchAcDetail(query)
    }
    loadAcDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        // console.log(query)
        await this.detailBloc.fetchAcData(query)
    }
    componentDidMount() {
        this.loadAcData()
        this.loadAcDetail()
        this.detailBloc.acDataChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            acData : response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.detailBloc.acDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log('detail')
                        // console.log(response)
                        this.setState({
                            acDetail : response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

       
    }
    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["name"] = data.level_name;
          newObj["level"] = data.level_no;
      
          return newObj;
        });
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Assesment</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Detail Data Manajerial
                                    </CardSubtitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Pegawai
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.acData ?
                                                    <>{this.state.acData.employee_full_name !== "" ? this.state.acData.employee_full_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.acData ?
                                                    <>{this.state.acData.employee_current_position_name !== "" ? this.state.acData.employee_current_position_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Unit Kerja
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.acData ?
                                                    <>{this.state.acData.employee_current_work_unit_name !== "" ? this.state.acData.employee_current_work_unit_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Periode
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.acData ?
                                                    <>{(this.state.acData.period_assess_name != "") ? this.state.acData.period_assess_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Tanggal Assesment
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.acData ?
                                                    <>{(this.state.acData.assessment_date != "") ? moment(this.state.acData.assessment_date).format('DD/MM/YYYY') : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Tujuan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.acData ?
                                                    <>{this.state.acData.assessment_goal !== "" ? this.state.acData.assessment_goal : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Assesor
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.acData ?
                                                    <>{this.state.acData.assessment_assessor_name !== "" ? this.state.acData.assessment_assessor_name : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Kinerja Pegawai
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.acData ?
                                                    <>{this.state.acData.assessment_performance !== "" ? this.state.acData.performance_name+"("+this.state.acData.assessment_performance+")" : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <div>
                                    <hr />
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '1' },{ customactivetab: this.state.activeTab === '1' })}
                                                    onClick={() => { this.toggle('1'); }}
                                                >
                                                    PROFIL KOMPT.
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '2' },{ customactivetab: this.state.activeTab === '2' })}
                                                    onClick={() => { this.toggle('2'); }}
                                                >
                                                    HASIL KOMPT.
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '3' },{ customactivetab: this.state.activeTab === '3' })}
                                                    onClick={() => { this.toggle('3'); }}
                                                >
                                                    MATRIX TALENT
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '4' },{ customactivetab: this.state.activeTab === '4' })}
                                                    onClick={() => { this.toggle('4'); }}
                                                >
                                                    SARAN PENGEMBANGAN
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '5' },{ customactivetab: this.state.activeTab === '5' })}
                                                    onClick={() => { this.toggle('5'); }}
                                                >
                                                    KESESUAIAN PENEMPATAN
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <TabContent activeTab={this.state.activeTab}>
                                            <TabPane tabId="1">
                                                <Row>
                                                    <Col sm="12">
                                                        <div style={{padding:'15px'}}>
                                                            {
                                                                this.state.acData != null ?
                                                                <KomptLengkap posuuid={this.state.acData.assessment_emp_position_uuid} uuid={this.props.uuid}/> :
                                                                <Shimmer><div style={{width: 500, height: 30}}></div></Shimmer>
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tabId="2">
                                                <Row>
                                                    <Col sm="12">
                                                        <div style={{padding:'15px'}}>
                                                            {
                                                                this.state.acData != null ?
                                                                <Kompt posuuid={this.state.acData.assessment_emp_position_uuid} uuid={this.props.uuid}/> :
                                                                <Shimmer><div style={{width: 500, height: 30}}></div></Shimmer>
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tabId="3">
                                                <Row>
                                                    <Col sm="12">
                                                    <div style={{padding:'15px'}}>
                                                            {
                                                                this.state.acData != null ?
                                                                <MatrixKinerja matrixid={this.state.acData.assessment_matrix} /> :
                                                                <Shimmer><div style={{width: 500, height: 30}}></div></Shimmer>
                                                            }

                                                            {/* <MatrixKinerja posuuid={this.state.acData.assessment_emp_position_uuid} uuid={this.props.uuid}/> */}
                                                            
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tabId="4">
                                                <Row>
                                                    <Col sm="12">
                                                        <div style={{padding:'15px'}}>
                                                            <br/>
                                                           <b>ISI SARAN PENGEMBANGAN </b><br/>
                                                            {
                                                                this.state.acData != null ?
                                                                <SaranPengembangan uuid={this.props.uuid}/> :
                                                                <Shimmer><div style={{width: 500, height: 30}}></div></Shimmer>
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tabId="5">
                                                <Row>
                                                    <Col sm="12">
                                                        <div style={{padding:'15px'}}>
                                                            <br/>
                                                           <b>ISI KESESUAIAN PENEMPATAN </b><br/>
                                                           {
                                                                this.state.acData != null ?
                                                                <KesesuaianPenempatan uuid={this.props.uuid} echeloncode={this.state.acData.echelon_code}/> :
                                                                <Shimmer><div style={{width: 500, height: 30}}></div></Shimmer>
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                        </TabContent>

                                    </div>
                                    <br />
                                    {/* <Row className="mb-3">
                                        <label className="col-md-3">
                                        Hasil Kompetensi
                                        </label>
                                        <Col md="9">
                                        <table className="table">
                                                <thead style={{background:"lavender"}}>
                                            {
                                                this.state.acData ?
                                                    <>{

                                                        this.state.acDetail.map((data, index) => {
                                                            return (
                                                                <>
                                                                    <tr>
                                                                        <th>
                                                                            {(data.competence_name!=undefined)?(index+1)+'. '+data.competence_name:'-'}
                                                                        </th>
                                                                        <th>
                                                                            {'Level-'+data.level_no+' '+data.level_name}
                                                                        </th>
                                                                    </tr>
                                                                </>  
                                                            )
                                                        })

                                                    }</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                            </thead>
                                        </table>
                                        </Col>
                                    </Row> */}
                                    
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="/assesment/manajerial.html" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);